jQuery(function($){

	// Search forms
	$(document).on('submit', '.search_form', function(e) {
		var searchQuery = $(this).find('input').val().replace(/ /g, '+');
		var placeHolder = $(this).find('input').attr('placeholder').replace(/ /g, '+');

		if ( !(searchQuery.length && searchQuery != placeHolder) ) {
			e.preventDefault();
			e.stopPropagation();
		};
	});

	// Product quantity box
	$(document).on("focusout",".quantity_input",function(){var a=$(this).val();isNaN(parseFloat(a))&&!isFinite(a)||0==parseInt(a)||""==a?$(this).val(1):parseInt(a)<0?$(this).val(parseInt(a)-2*parseInt(a)):$(this).val(parseInt(a))}),$(document).on("click",".quantity_up",function(){var a=$(this).parent().find(".quantity_input");isNaN(parseFloat(a.val()))||!isFinite(a.val())||a.attr("disabled")?a.val(1):a.val(parseInt(a.val())+1)}),$(document).on("click",".quantity_down",function(){var a=$(this).parent().find(".quantity_input");!isNaN(parseFloat(a.val()))&&isFinite(a.val())&&a.val()>1&&!a.attr("disabled")?a.val(parseInt(a.val())-1):a.val(1)});

	// RTE youtube wrapper
	$(document).ready(function() {
		if ( $('.rte').length ) {
			$('.rte iframe[src *= youtube]').wrap('<div class="rte_youtube_wrapper"></div>');
		};
	});

	// Back to top button
	$(document).ready(function(){
		$(window).on('scroll', function(){
			if ( $(this).scrollTop() > 300 ) {
				$('#back_top').fadeIn("slow");
			}
			else {
				$('#back_top').fadeOut("slow");
			};
		});
		$('#back_top').on('click', function(e) {
			e.preventDefault();
			$('html, body').animate( {scrollTop : 0}, 800 );
			$('#back_top').fadeOut("slow").stop();
		});
	});

	// Collection item hover effect
	(function ($) {
		var o = $(".collection_item");
		if (o.length > 0) {
			$(document).ready(function () {

				$('body').delegate('.collection_caption', 'mouseover', function () {
					$(this).addClass('rollOut');
				});

				$('body').delegate('.collection_caption', 'mouseout', function () {
					$(this).removeClass('rollOut');
				});

			});
		}
	})(jQuery);

	// Form validation
	$.fn.formValidation = function() {
		this.find('input[type=text], input[type=email], textarea').after('<p class="alert alert-danger alert-inline" style="display: none;"></p>');
		this.find('input[type=password]').parents('.form-control-content').append('<p class="alert alert-danger alert-inline" style="display: none;"></p>');

		this.on('submit', function(event) {
			$(this).find('input[type=text], input[type=email], input[type=password], textarea').each(function() {

				if ( $(this).val() == '' ) {
					$(this).addClass('alert-inline');
					if ($(this).attr('type') === 'password'){
						$(this).parents('.form-control-content').find('.alert').html('Field can\'t be blank').slideDown();
					}else{
						$(this).next().html('Field can\'t be blank').slideDown();

					}
					$(this).on('focus', function() {
						$(this).removeClass('alert-inline').next().slideUp();
					});
					event.preventDefault();
				};
			});

			if ( $(this).find('input[type=email]').length ) {
				var inputEmail = $(this).find('input[type=email]');
				if ( inputEmail.val().length > 0 && ( inputEmail.val().length < 6 || inputEmail.val().indexOf("@") == -1 || inputEmail.val().indexOf(".") == -1 ) ) {
					inputEmail.addClass('alert-inline').next().html('Incorrect email').slideDown();
					inputEmail.on('focus', function() {
						$(this).removeClass('alert-inline').next().slideUp();
					});
					event.preventDefault();
				};
			};

			if ( $(this).find('input[type=password]').length == 2 ) {
				var pwd1 = $(this).find('input[type=password]:eq(0)');
				var pwd2 = $(this).find('input[type=password]:eq(1)');

				if ( pwd1.val() != pwd2.val() ) {
					pwd1.addClass('alert-inline');
					pwd2.addClass('alert-inline').parents('.form-control-content').find('.alert').html('Passwords do not match').slideDown();

					pwd1.on('focus', function() {
						pwd1.removeClass('alert-inline');
						pwd2.removeClass('alert-inline').parents('.form-control-content').find('.alert').slideUp();
					});

					pwd2.on('focus', function() {
						pwd1.removeClass('alert-inline');
						pwd2.removeClass('alert-inline').parents('.form-control-content').find('.alert').slideUp();
					});
					event.preventDefault();
				};
			};
		});
	};

	$('.footer_newsletter_form').formValidation();

	// Show/Hide password input
	$(document).ready(function(){
		$('[data-action="show-password"]').on('click', function () {
			var elm = $(this).closest('.input-group').children('input.js-visible-password');
			if (elm.attr('type') === 'password') {
				elm.attr('type', 'text');
				$(this).html('<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="file_eye_el"><path d="M0.0999997 10.5C-0.1 11 0.2 11.6 0.7 11.8C1.2 12 1.8 11.7 2 11.2C3.6 8.00002 6.6 5.90002 10 5.90002C13.4 5.90002 16.5 8.00002 17.9 11.2C18.1 11.7 18.7 12 19.2 11.8H19.3C19.9 11.6 20.2 11 19.9 10.5C19.3 9.20002 18.5 8.00002 17.5 7.10002C17.1 6.70002 17 6.20002 17.3 5.80002L17.6 5.30002C17.9 4.80002 17.7 4.20002 17.2 3.90002C16.7 3.60002 16.1 3.80002 15.8 4.30002L15.7 4.50002C15.4 5.00002 14.8 5.10002 14.3 4.90002C13.5 4.60002 12.7 4.30002 11.9 4.10002C11.4 4.00002 11 3.60002 11 3.10002V2.90002C11 2.30002 10.5 1.90002 10 1.90002C9.4 1.90002 9 2.40002 9 2.90002V3.10002C9 3.60002 8.6 4.00002 8.1 4.10002C7.3 4.20002 6.5 4.50002 5.8 4.80002C5.3 5.00002 4.6 4.90002 4.3 4.40002L4.2 4.30002C4 3.80002 3.4 3.70002 2.9 3.90002C2.4 4.20002 2.2 4.80002 2.5 5.30002L2.8 5.70002C3.1 6.10002 3 6.70002 2.6 7.00002C1.5 8.00002 0.7 9.20002 0.0999997 10.5Z" /><path d="M19.9 10.6C18.2 6.6 14.3 4 10 4C5.7 4 1.8 6.6 0.2 10.6L0 11L0.2 11.4C1.9 15.4 5.7 18 10.1 18C14.4 18 18.3 15.4 19.9 11.4L20 11L19.9 10.6ZM10 16C6.6 16 3.6 14.1 2.2 11C3.6 7.9 6.6 6 10 6C13.4 6 16.4 7.9 17.8 11C16.4 14.1 13.4 16 10 16Z" /><path d="M10 8C8.4 8 7 9.3 7 11C7 12.7 8.3 14 10 14C11.7 14 13 12.7 13 11C13 9.3 11.7 8 10 8ZM10 12C9.5 12 9 11.6 9 11C9 10.4 9.4 10 10 10C10.6 10 11 10.4 11 11C11 11.6 10.6 12 10 12Z" /></svg>');
				console.log(2);
			} else {
				elm.attr('type', 'password');
				$(this).html('<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="file_eye_el"><path d="M19.9213 6.33664C20.1557 5.81077 19.844 5.21824 19.2848 5.05073C18.7566 4.89251 18.1987 5.17332 17.9664 5.66527C16.4415 8.89505 13.3725 10.966 10.0416 10.966C6.6215 10.966 3.54948 8.90232 2.10083 5.68227C1.876 5.18253 1.32023 4.88805 0.785864 5.04012L0.728076 5.05657C0.155103 5.21963 -0.161611 5.82638 0.0839321 6.36027C0.677994 7.65193 1.46566 8.82793 2.44692 9.79417C2.80378 10.1456 2.90358 10.6891 2.64628 11.1163L2.37452 11.5674C2.08511 12.0479 2.25306 12.668 2.74729 12.9438C3.22751 13.2118 3.83775 13.0542 4.12169 12.589L4.23541 12.4027C4.52288 11.9316 5.1386 11.7753 5.64786 12.0022C6.39877 12.3366 7.2005 12.6011 8.01571 12.7778C8.51904 12.8869 8.90067 13.3108 8.90067 13.817V13.9866C8.90067 14.5463 9.3679 15 9.93786 15C10.5078 15 10.9751 14.5463 10.9751 13.9866V13.817C10.9751 13.3108 11.3565 12.887 11.8618 12.7872C12.6628 12.6289 13.4508 12.3976 14.1903 12.0598C14.7189 11.8183 15.372 11.963 15.6717 12.4541L15.754 12.589C16.038 13.0542 16.6482 13.2118 17.1284 12.9438C17.6227 12.668 17.7906 12.0479 17.5012 11.5674L17.2439 11.1403C16.9803 10.7027 17.0921 10.1451 17.4697 9.79728C18.5171 8.83258 19.3228 7.67903 19.9213 6.33664Z"/></svg>');
				console.log(3);
			}
			console.log(1);
		});
	});

	// Product quick view
	jQuery(function($){
		$(document.body).on('click', '.js_quick_view', function(e) {
			e.preventDefault();

			// CONSTRUCTING QUICK VIEW MODAL
				

			$(document.body).append("\n\t\t\t\t\u003cdiv id=\"product_quick_view\" style=\"display: none;\"\u003e\n\t\t\t\t\t\u003cdiv class=\"product_quick_wrapper row\"\u003e\n\t\t\t\t\t\t\u003cdiv class=\"quick_view__left col-12 col-md-7 col-lg-6 mb-3 mb-md-0\"\u003e\n\t\t\t\t\t\t\t\u003cdiv id=\"img_big\"\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\u003cdiv class=\"product_images\"\u003e\n\t\t\t\t\t\t\t\t\u003cdiv id=\"img_gallery\" class=\"swiper-container\"\u003e\n\t\t\t\t\t\t\t\t\t\u003cdiv class=\"swiper-wrapper\"\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\t\u003cdiv class=\"quick_view__right col-12 col-md-5 col-lg-6\"\u003e\n\t\t\t\t\t\t\t\u003cform action=\"\/cart\/add\" method=\"post\" enctype=\"multipart\/form-data\" id=\"product-actions\" class=\"quick_view_form\"\u003e\n\t\t\t\t\t\t\t\t\u003ch3 id=\"quick_view__name\" class=\"mt-0 mb-2\"\u003e\u003c\/h3\u003e\n\t\t\t\t\t\t\t\t\u003cp id=\"quick_view__description\"\u003e\u003c\/p\u003e\n\t\t\t\t\t\t\t\t\u003cdiv id=\"quick_view__price\" class=\"product-price-container\"\u003e\u003c\/div\u003e\n\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\u003cp id=\"quick_view__variants\"\u003e\n\t\t\t\t\t\t\t\t\t\u003clabel for=\"\"\u003eOptions:\u003c\/label\u003e\n\t\t\t\t\t\t\t\t\t\u003cselect id=\"product-select\" name=\"id\" class=\"hidden\"\u003e\u003c\/select\u003e\n\t\t\t\t\t\t\t\t\u003c\/p\u003e\n\t\t\t\t\t\t\t\t\u003cdiv id=\"quick_view_colors\"\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\u003cdiv id=\"quick_view_size\"\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\u003cdiv id=\"quick_view__form\" class=\"product-quantity\"\u003e\n\t\t\t\t\t\t\t\t\t\u003clabel for=\"quantity\"\u003eQuantity:\u003c\/label\u003e\n\t\t\t\t\t\t\t\t\t\u003cdiv class=\"quantity_box mr-1\"\u003e\n\t\t\t\t\t\t\t\t\t\t\u003cinput min=\"1\" type=\"text\" name=\"quantity\" value=\"1\" class=\"quantity_input form-control\" \/\u003e\n\t\t\t\t\t\t\t\t\t\t\u003cdiv class=\"quantity_modifier quantity_up\"\u003e\u003csvg width=\"9\" height=\"6\" viewBox=\"0 0 9 6\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"\u003e\u003cpath d=\"M9 4.5L7.5 6L4.5 3L1.5 6L0 4.5L4.5 0L9 4.5Z\"\/\u003e\u003c\/svg\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\t\t\u003cdiv class=\"quantity_modifier quantity_down\"\u003e\u003csvg width=\"9\" height=\"6\" viewBox=\"0 0 9 6\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"\u003e\u003cpath d=\"M9 1.5L7.5 0L4.5 3L1.5 0L0 1.5L4.5 6L9 1.5Z\" \/\u003e\u003c\/svg\u003e\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\t\t\t\t\u003cbutton class=\"btn btn-primary btn-add-to-cart icon-svg mr-1\" type=\"submit\" id=\"quick_view__add\"\u003e\n\t\t\t\t\t\t\t\t\t\t\u003csvg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"\u003e\n\t\t\t\t\t\t\t\t\t\t\u003cpath d=\"M18,14H7c-0.6,0-1-0.4-1-1s0.4-1,1-1h10.1l0.8-6H5C4.4,6,4,5.6,4,5s0.4-1,1-1h14c0.3,0,0.6,0.1,0.8,0.3 C19.9,4.6,20,4.8,20,5.1l-1,8C18.9,13.6,18.5,14,18,14z\"\u003e\u003c\/path\u003e\n\t\t\t\t\t\t\t\t\t\t\u003cpath d=\"M7,14c-0.4,0-0.8-0.3-1-0.7L3.1,2H1C0.4,2,0,1.6,0,1s0.4-1,1-1h2.8c0.5,0,0.9,0.3,1,0.7l3.2,12 c0.1,0.5-0.2,1.1-0.7,1.2C7.2,14,7.1,14,7,14z\"\u003e\u003c\/path\u003e\n\t\t\t\t\t\t\t\t\t\t\u003ccircle cx=\"8\" cy=\"18\" r=\"2\"\u003e\u003c\/circle\u003e\n\t\t\t\t\t\t\t\t\t\t\u003ccircle cx=\"17\" cy=\"18\" r=\"2\"\u003e\u003c\/circle\u003e\n\t\t\t\t\t\t\t\t\t\t\u003c\/svg\u003e\n\t\t\t\t\t\t\t\t\t\tAdd to cart\n\t\t\t\t\t\t\t\t\t\u003c\/button\u003e\n                                    \n                                    \u003cdiv class=\"single_product__wishlist\"\u003e         \n                                 \u003cdiv class=\"iwishAddWrap\"\u003e\n                                   \u003ca class=\"iWishAdd wishlist_btn wishlist_login\" href=\"#\" data-product=\"\" data-pTitle= \"\"\u003e\u003cspan class=\"wishlist-icon\"\u003e\u003c\/span\u003e\u003c\/a\u003e\n\t                                \n                                \u003c\/div\u003e  \n                               \u003c\/div\u003e\n\t\t\t\t\t\t\t\t\n                             \u003c\/div\u003e\n                               \n\t\t\t\t\t\t\t\u003c\/form\u003e\n\t\t\t\t\t\t\t\u003cdiv id=\"product_info_link\"\u003e\n\t\t\t\t\t\t\t\t\u003ca href=\"#\" class=\"link link-primary\"\u003eView Full Info\u003c\/a\u003e\n\t\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\u003c\/div\u003e\n\t\t\t");

			// Showing fancybox loading animation
			$.fancybox.showLoading();
			$.fancybox.helpers.overlay.open({parent: $('body')});

			// Getting product info (Json)
			$.getJSON( $(this).attr( 'href' ) + '.js', function( product ) {

				// Toggle big image when clicking a thumn
				$(document).on('click', '#img_gallery a', function(e) {
					e.preventDefault();
					var newHREF = $(this).attr('href');
					$('#product_quick_view #img_big img').attr('src', newHREF );
				});

				// PRODUCT TITLE
				var productTitle = product.title;
				$('#quick_view__name').html( '<a href="' + product.url + '">' + productTitle + '</a>' );
            
				// PRODUCT DESCRIPTION
				var productDescription = $.trim( product.description ).substring(0, 200) + '...';
				$('#quick_view__description').html( productDescription );

				// PRODUCT TYPE
				$('#quick_view__type span').html( product.type );

				// PRODUCT VENDOR
				$('#quick_view__vendor span').html( product.vendor );

				// PRODUCT VARIANTS
				$.each(product.variants, function(i, variant) {
					$('#product-select').append('<option value="' + variant.id + '">' + variant.title + ' - ' + variant.price + '</option>')
				});

				// PRODUCT ALL INFO LINK
				$('#product_info_link a').attr( 'href', product.url );

				// QUANTITY FORM MINI
				$("#quantity").on("focusout",function(){var t=$(this).val();$(this).val(isNaN(parseFloat(t))&&!isFinite(t)||0==parseInt(t)||""==t?1:parseInt(t)<0?parseInt(t)-2*parseInt(t):parseInt(t))}),$("#quantity_up").on("click",function(){var t=$("#quantity").val();$("#quantity").val(!isNaN(parseFloat(t))&&isFinite(t)?parseInt(t)+1:1)}),$("#quantity_down").on("click",function(){var t=$("#quantity").val();$("#quantity").val(!isNaN(parseFloat(t))&&isFinite(t)&&t>1?parseInt(t)-1:1)});
                 
              /*iwish atributes---------------------------------*/
              $('.iWishAdd').attr('data-pTitle', productTitle );
              $('.iWishAdd').attr('data-product', product.id );
              
				// UPLOADING option_selection.js TO MANAGE PRODUCT VARIANTS
				$.getScript( "//www.catchndealz.com/cdn/shopifycloud/shopify/assets/themes_support/option_selection-86cdd286ddf3be7e25d68b9fc5965d7798a3ff6228ff79af67b3f4e41d6a34be.js", function() {

					// IMAGES PRELOADER (FUNCTION)
					function preloadImages(images, callback) {
						var count = images.length;
						if (count === 0) {
							callback();
						}
						var loaded = 0;
						$(images).each(function() {
							$('<img>').attr('src', this).load(function() {
								loaded++;
								if (loaded === count) {
									callback();
								}
							});
						});
					};

					// IMAGES PRELOADER (INIT)
					preloadImages( product.images, function() {

						// APPENDING BIG IMAGE
						var bigImgUrl = product.images[0].replace('.png', '_540x540_crop_center.png').replace('.jpg', '_540x540_crop_center.jpg');
						$('#product_quick_view #img_big').append( '<img class="img-fluid" src="' + bigImgUrl + '" alt="" />' );

						// APPENDING ALL IMAGES TO GALLERY
						$.each(product.images, function(i, src) {
							var smallSrc = src.replace('.png', '_58x58_crop_center.png').replace('.jpg', '_58x58_crop_center.jpg');
							var bigSrc = src.replace('.png', '_540x540_crop_center.png').replace('.jpg', '_540x540_crop_center.jpg');
							$('#img_gallery .swiper-wrapper').append( '<a class="swiper-slide" href="' + bigSrc + '"><img class="img-fluid" src="' + smallSrc + '" alt="" /></a>' );
						});

						// ADDING THUMBS SLIDER
						var quickViewGallery = new Swiper('#img_gallery', {
							slidesPerView: 5,
							spaceBetween: 11,
							slideToClickedSlide: true,
							direction: 'horizontal',
							breakpoints: {
								400: {
									slidesPerView: 6
								},
								768: {
									slidesPerView: 7
								},
								992: {
									slidesPerView: 7
								},
								1200: {
									slidesPerView: 8
								}
							}
						});

						// VARIANT CHANGE FUNCTION
						var selectCallback = function(variant, selector) {
							if ( variant && variant.available ) {
								jQuery('#quick_view__add').removeAttr('disabled').removeClass('disabled');
								// VARIANT PRICES
								if( variant.price < variant.compare_at_price ){
									jQuery('#quick_view__price').html('<span class="product-price with-discount item_price money d-block mb-1">' + Shopify.formatMoney(variant.price, "") + '</span><span class="compare-at-price product-regular-price money">' + Shopify.formatMoney(variant.compare_at_price, "") + '</span><span class="product-sale-price money">Save ' + parseInt( 100 - ( variant.price*100 )/variant.compare_at_price ) + '%</span>');
								}
								else {
									jQuery('#quick_view__price').html('<span class="product-price item_price money">' + Shopify.formatMoney(variant.price, "") + '</span>');
								};

								// PRODUCT QUANTITY
								if ( variant.inventory_management != null ) {
									jQuery('#quick_view__availability span').removeClass('notify_danger').addClass('notify_success').html('Available');
								}
								else {
									jQuery('#quick_view__availability span').removeClass('notify_danger').addClass('notify_success').html( 'Available' );
								};
							} else {
								jQuery('#quick_view__add').addClass('disabled').attr('disabled', 'disabled'); // set add-to-cart button to unavailable class and disable button
								jQuery('#quick_view__availability span').removeClass('notify_success').addClass('notify_danger').html( 'Unavailable' );
								jQuery('#quick_view__price').html('<span class="product-price money">' + Shopify.formatMoney(variant.price, "") + '</span>');
							};

							// COLOR & SIZE OPTIONS
							for (var i = 0; i < selector.product.options.length; i++) {
								if ( selector.product.options[i].name.toLowerCase() == 'color' ) {
										var selectorNum = i;
										var selectorName = selector.product.options[i].name;

									renderColorOptions(selectorNum, selectorName);
								};
								if ( selector.product.options[i].name.toLowerCase() == 'size' ) {
										var selectorNum = i;
										var selectorName = selector.product.options[i].name;

									renderSizeOptions(selectorNum, selectorName);
								};
							};

							// CHANGING VARIANT IMAGE
							if ( variant && variant.featured_image ) {
								var originalImage = $("#img_big img");
								var newImage = variant.featured_image;
								var element = originalImage[0];

								Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
									$('#img_big img').attr('src', newImageSizedSrc);
									quickViewGallery.slides.each(function(i) {
										var thumb = $(this).find('img').attr('src').replace('_70x70_crop_top', '').replace('_70x70_crop_center', '').replace('_70x70_crop_bottom', '').replace(/\?v=.*/ , '');
										var newImg = newImageSizedSrc.replace('_380x380', '').replace(/\?v=.*/ , '');
										if ( thumb == newImg ) {
											quickViewGallery.slideTo(i);
										};
									});
								});
							};

							currencyToggle('#quick_view__price .money');
						};

						// VARIANT CHANGE FUNCTION (INIT)
						new Shopify.OptionSelectors( "product-select",
						{
							product: product,
							onVariantSelected: selectCallback,
							enableHistoryState: false
						});

						// HIDING DEFAULT VARIANT SELECTOR
						$.each( $('#quick_view__variants select option'), function() {
							if ( $(this).val() == 'Default Title' ) {
								$('#quick_view__variants').hide();
							};
						});

						// SHOWING QUICK VIEW MODAL
						$.fancybox( $('#product_quick_view'),
							{
								'openSpeed': 500,
								'closeSpeed': 500,
								'tpl': {
									wrap: '<div id="quick_view__wrap" class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
									closeBtn : '<a title="Close" id="quick_view__close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
								},
								'afterClose': function() {
									$('#product_quick_view').remove(); // REMOVING QUICK VIEW MODAL AFTER CLOSE
                                    //console.log("closing-----------");
                                    if(typeof iwishCheckColl !== 'undefined' && typeof iwishCheckColl === 'function') { iwishCheckColl(); }
								}
							}
						);
					});
				});

				function renderColorOptions(num, name) {
					var colorSelect = $('#product_quick_view .single-option-selector').eq(num);
					var selectId = '#' + colorSelect.attr('id');
					var container = $('#product_quick_view #quick_view_colors');
					var content = '<label>' + name + ': </label>';

					colorSelect.parent('.selector-wrapper').addClass('hidden');

					if ( $('#product_quick_view .single-option-selector').length == 1 ) {
						$('#quick_view__variants label').hide();
					}

					$('#product_quick_view ' + selectId + ' option' ).each(function(){
						var value = $(this).val();
						if ( colorSelect.val() == value ) {
							return content = content + '<div class="color_item current" data-val="' + value + '" title="' + value + '"><span class="color_inner" style="background-color: ' + value + '"></span></div>';
						} else {
							return content = content + '<div class="color_item" data-val="' + value + '" title="' + value + '"><span class="color_inner" style="background-color: ' + value + '"></span></div>';
						}
					});
					container.html(content);
					$('#product_quick_view .color_item').on('click', function(e){
						colorSelect.val( $(this).data('val') ).trigger('change');
					});
				};
				// RENDER SIZE OPTION
				function renderSizeOptions(num, name){
					var sizeSelect = $('#product_quick_view .single-option-selector').eq(num);
					var selectId = '#' + sizeSelect.attr('id');
					var container = $('#product_quick_view #quick_view_size');
					var content = '<label>' + name + ': </label>';
					sizeSelect.parent('.selector-wrapper').addClass('hidden');
					if ( $('#product_quick_view .single-option-selector').length == 1 ) {
						$('#quick_view__variants label').hide();
					}
					$('#product_quick_view ' + selectId + ' option' ).each(function(){
						var value = $(this).val();
						if ( sizeSelect.val() == value ) {
							return content = content + '<div class="size_item current" data-val="' + value + '"><span class="size_inner">' + value + '</span></div>';
						} else {
							return content = content + '<div class="size_item" data-val="' + value + '"><span class="size_inner">' + value + '</span></div>';
						};
					});
					container.html(content);
					$('#product_quick_view .size_item').on('click', function(e){
						sizeSelect.val( $(this).data('val') ).trigger('change');
					});
				};

				// CLOSING QUICK VIEW MODAL AFTER ADDING TO CART
				$('#quick_view__add').on('click', function() {
					$.fancybox.close();
				});
			});
		});
	});

	function currencyToggle(target) {
		// SWITCH CURRENCY
		if ( typeof theme.shopCurrency != 'undefined' ) {
			var newCurrency = Currency.cookie.read();
			Currency.convertAll( theme.shopCurrency, newCurrency, target, 'money_format' ); 
		}
	};

//checkout
	// AJAX CART
	function ajaxCartRender() {
		$('.cart_content_preloader').removeClass('off');
		jQuery.getJSON('/cart.js', function(data) {
			var newHtml = '';

			if ( data.items.length == 0 ) {
				newHtml += '<h4 class="cart-content-header">Cart</h4><p class="alert alert-warning mb-0">' + theme.cartAjaxTextEmpty + '</p>';
			} else {
				data.items.forEach( function( item, i ) {
					var image_url = item.image.replace('.png','_100x100_crop_center.png').replace('.jpg','_100x100_crop_center.jpg');
					newHtml += '<li class="cart_items"><img class="product-thumbnail item_img img-fluid" src="' + image_url + '"  alt="' + item.title + '" /><div class="item_desc"><a class="product_title" href="' + item.url + '">' + item.title.slice(0,50) + '</a><p class="product_quantity mb-2">Quantity: ' + item.quantity + '</p><div class="product-price product-price-sm"><span class="money product-price">' + Shopify.formatMoney(item.price, theme.moneyFormat) + '</span></div><a class="item_remove_btn" href="#" item-id="' + item.id + '"><svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 7H5V15C5 16.6569 6.34315 18 8 18H12C13.6569 18 15 16.6569 15 15V7ZM3 5V15C3 17.7614 5.23858 20 8 20H12C14.7614 20 17 17.7614 17 15V5H3Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14 3H6C4.69378 3 3.58254 3.83481 3.17071 5H16.8293C16.4175 3.83481 15.3062 3 14 3ZM18.9 5C18.4367 2.71776 16.419 1 14 1H6C3.58104 1 1.56329 2.71776 1.10002 5C1.03443 5.32311 1 5.65753 1 6V7H19V6C19 5.65753 18.9656 5.32311 18.9 5Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C8.44772 0 8 0.447715 8 1C8 1.55228 8.44772 2 9 2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0H9Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M7 15C7 15.5523 7.44772 16 8 16C8.55228 16 9 15.5523 9 15L9 10C9 9.44772 8.55228 9 8 9C7.44771 9 7 9.44772 7 10L7 15Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15L13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10L11 15Z" /></svg></a></div></li>';
				});

				newHtml += '<div class="box_footer"><a id="clear_cart_all_items" class="cart_clear link link-primary icon-out" href="/cart/clear">Clear cart<svg width="14" height="14" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> <path d="M17.7071 2.29289C18.0976 2.68342 18.0976 3.31658 17.7071 3.70711L11.4142 10L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289L16.2929 2.29289C16.6834 1.90237 17.3166 1.90237 17.7071 2.29289Z"/><path d="M2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L8.58579 10L2.29289 16.2929C1.90237 16.6834 1.90237 17.3166 2.29289 17.7071C2.68342 18.0976 3.31658 18.0976 3.70711 17.7071L10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289Z"/> </svg></a><div class="cart_total d-flex flex-wrap justify-content-between mt-2"><span class="label">' + theme.cartAjaxTextTotalPrice + ': </span><span class="product-price money value">' + Shopify.formatMoney(data.total_price, theme.moneyFormat)  + '</span></div><a class="btn btn-secondary btn-block w-100 my-3" href="/checkout">Checkout</a><div class="d-block cart-top-line pt-2"><a class="link link-primary arrow-left" href="/cart">' + theme.cartAjaxTextGoCart + '</a></div></div>';
			}

			$('#cart_content_box').html(newHtml);
			$('.header_cart #cart_items').html(data.item_count).removeClass('hidden');
			removeItemFromCart();
			clearAllItemsFromCart();
			$('.cart_content_preloader').addClass('off');
		});
	};


	// REMOVE AJAX CART ITEMS
	function removeItemFromCart(){
		$('.header_cart .item_remove_btn').on('click', function(e){
			e.preventDefault();
			itemId = this.getAttribute('item-id');
			var postData = "updates[" + itemId + "]=0";
			jQuery.post('/cart/update.js', postData, function(){
				ajaxCartRender();
			});
		});
	};
	removeItemFromCart();

	// CLEAR AJAX CART 
	function clearAllItemsFromCart(){
		$('#cart_content_box #clear_cart_all_items').on('click', function(e){
			e.preventDefault();

			jQuery.post('/cart/clear.js', function(){
				ajaxCartRender();
			});
		});
	};
	clearAllItemsFromCart();

	// JQUERY.AJAX-CART.JS MINI
	jQuery(document).ready(function(t){var e={TOTAL_ITEMS:".cart-total-items",TOTAL_PRICE:".cart-total-price",SUBMIT_ADD_TO_CART:"input[type=image], input.submit-add-to-cart",FORM_UPDATE_CART:"form[name=cartform]",FORM_UPDATE_CART_BUTTON:"form[name=cartform] input[name=update]",FORM_UPDATE_CART_BUTTONS:"input[type=image], input.button-update-cart",LINE_ITEM_ROW:".cart-line-item",LINE_ITEM_QUANTITY_PREFIX:"input#updates_",LINE_ITEM_PRICE_PREFIX:".cart-line-item-price-",LINE_ITEM_REMOVE:".remove a",EMPTY_CART_MESSAGE:"#empty"},a=function(t){return Shopify.formatMoney(t,"${{ amount }}")};t(document).on("submit",'form[action*="/cart/add"]',function(e){e.preventDefault(),t(e.target).find(".btn-cart").attr("disabled",!0).addClass("disabled"),Shopify.addItemFromForm(e.target)}),t(document).on("click",".btn-cart",function(){t.fancybox.showLoading(),t.fancybox.helpers.overlay.open({parent:t("body")})}),t(e.FORM_UPDATE_CART_BUTTON).click(function(a){a.preventDefault(),t(a.target.form).find(e.FORM_UPDATE_CART_BUTTONS).attr("disabled",!0).addClass("disabled"),Shopify.updateCartFromForm(a.target.form)}),t(e.FORM_UPDATE_CART).delegate(e.LINE_ITEM_REMOVE,"click",function(a){a.preventDefault();var i=this.href.split("/").pop().split("?").shift();Shopify.removeItem(i),t(this).parents(e.LINE_ITEM_ROW).remove()}),Shopify.onItemAdded=function(e,a){t(a).find(".btn-cart").attr("disabled",!1).removeClass("disabled"),Shopify.getCart()},Shopify.onCartUpdate=function(i,n){t("#cart_items").html(i.item_count);if(theme.cartAjaxOn){ajaxCartRender();}var r=a(i.total_price);t(e.TOTAL_PRICE).html(r),t(e.EMPTY_CART_MESSAGE).length>0&&0==i.item_count&&(t(e.FORM_UPDATE_CART).hide(),t(e.EMPTY_CART_MESSAGE).show()),n=n||!1,n&&i.item_count>0&&(t.each(i.items,function(i,n){t(e.LINE_ITEM_PRICE_PREFIX+n.id).html(a(n.line_price)),t(e.LINE_ITEM_QUANTITY_PREFIX+n.id).val(n.quantity)}),t(n).find("input[value=0]").parents(e.LINE_ITEM_ROW).remove(),t(n).find(e.FORM_UPDATE_CART_BUTTONS).attr("disabled",!1).removeClass("disabled"))},Shopify.onError=function(){t("form").find(".btn-cart").attr("disabled",!1).removeClass("disabled")}});

  // JQUERY.API.JS MINI
  

  // JQUERY.API.JS FULL
	function floatToString(t, o) {
		var r = t.toFixed(o).toString();
		return r.match(/^\.\d+/) ? "0" + r : r
	}

	function attributeToString(t) {
		return "string" != typeof t && (t += "", "undefined" === t && (t = "")), jQuery.trim(t)
	}
	"undefined" == typeof Shopify && (Shopify = {}), Shopify.money_format = "$ {{amount}}", Shopify.onError = function(XMLHttpRequest, textStatus) {
		var data = eval("(" + XMLHttpRequest.responseText + ")");
		alert(data.message + "(" + data.status + "): " + data.description)
	}, Shopify.onCartUpdate = function(t) {
		alert("There are now " + t.item_count + " items in the cart.")
	}, Shopify.onItemAdded = function(t) {
		alert(t.title + " was added to your shopping cart.")
	}, Shopify.onProduct = function(t) {
		alert("Received everything we ever wanted to know about " + t.title)
	}, Shopify.formatMoney = function(t, o) {
		var r = "",
			e = /\{\{\s*(\w+)\s*\}\}/,
			a = o || this.money_format;
		switch (a.match(e)[1]) {
			case "amount":
				r = floatToString(t / 100, 2).replace(/(\d+)(\d{3}[\.,]?)/, "$1 $2");
				break;
			case "amount_no_decimals":
				r = floatToString(t / 100, 0).replace(/(\d+)(\d{3}[\.,]?)/, "$1 $2");
				break;
			case "amount_with_comma_separator":
				r = floatToString(t / 100, 2).replace(/\./, ",").replace(/(\d+)(\d{3}[\.,]?)/, "$1.$2")
		}
		return a.replace(e, r)
	}, Shopify.resizeImage = function(t, o) {
		try {
			if ("original" == o) return t;
			var r = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			return r[1] + "_" + o + "." + r[2]
		} catch (e) {
			return t
		}
	}, Shopify.addItem = function(t, o, r) {
		o = o || 1;
		var e = {
			type: "POST",
			url: "/cart/add.js",
			data: "quantity=" + o + "&id=" + t,
			dataType: "json",
			success: function(t) {
				"function" == typeof r ? r(t) : Shopify.onItemAdded(t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(e)
	}, Shopify.addItemFromForm = function(t, o) {
		var r = {
			type: "POST",
			url: "/cart/add.js",
			data: jQuery(t).serialize(),
			dataType: "json",
			success: function(r) {
				"function" == typeof o ? o(r, t) : Shopify.onItemAdded(r, t);

				$('body').append("\n    \u003cdiv id=\"cart_added\"\u003e\n\t\t\u003cdiv class=\"row no-gutters\"\u003e\n\t\t\t\u003cdiv class=\"col-12 col-md-6 left-info\"\u003e\n\t\t\t\t\u003ch5 class=\"cart-title\"\u003e\n\t\t\t\t\t\u003csvg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"\u003e\n\t\t\t\t\t\t\u003cpath d=\"M15.485 33C15.0057 33 7.13868 24.2727 1.3684 17.7744C0.432346 16.7203 1.41774 15.0926 2.78227 15.4351L13.6278 19.5402C14.1015 19.6591 14.603 19.5274 14.958 19.1907L32.5828 2.40929C33.814 1.24168 35.6765 2.80065 34.7508 4.22463C26.2606 17.2848 15.9312 33 15.485 33Z\" fill=\"#FDA828\"\/\u003e\n\t\t\t\t\t\t\u003cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.8946 1.68379C34.0089 -0.321358 37.1431 2.37935 35.5891 4.76976C31.3434 11.3008 26.6362 18.4981 22.9339 24.0638C21.0833 26.8458 19.4806 29.2249 18.3111 30.9106C17.7274 31.7519 17.2456 32.4291 16.8923 32.8997C16.7175 33.1326 16.5631 33.3296 16.438 33.4743C16.3779 33.5439 16.3062 33.6229 16.2308 33.692C16.1947 33.725 16.1342 33.7778 16.0561 33.8283L16.053 33.8303C16.0077 33.8598 15.7919 34.0001 15.4849 34.0001C15.1918 34.0001 14.9706 33.8712 14.9254 33.8448C14.9236 33.8438 14.922 33.8429 14.9208 33.8422C14.8366 33.7939 14.7608 33.739 14.7019 33.6938C14.5808 33.6008 14.4429 33.48 14.299 33.3472C14.0068 33.0774 13.6229 32.6959 13.1718 32.2324C12.2662 31.3019 11.0497 29.9993 9.67395 28.5003C6.92054 25.5003 3.50703 21.6892 0.620544 18.4385C-0.964693 16.6533 0.700869 13.8817 3.02564 14.4653L3.0819 14.4794L13.9114 18.5784C14.0402 18.5979 14.1723 18.5574 14.2694 18.4656C14.2695 18.4654 14.2692 18.4657 14.2694 18.4656L31.8946 1.68379ZM33.2708 3.13498C33.2706 3.13521 33.271 3.13476 33.2708 3.13498L15.646 19.9163C15.0432 20.488 14.1905 20.7126 13.3842 20.5102L13.3279 20.4961L2.49758 16.3967C2.11422 16.3366 1.83899 16.7985 2.11604 17.1106C4.99984 20.3582 8.40496 24.1598 11.1474 27.148C12.5197 28.6431 13.7204 29.9285 14.605 30.8375C14.899 31.1396 15.1537 31.3955 15.3655 31.6017C15.6899 31.1651 16.1291 30.5469 16.6679 29.7705C17.8259 28.1014 19.4199 25.7354 21.2687 22.9561C24.9652 17.3992 29.6678 10.2088 33.9123 3.67968C34.0061 3.53539 34.007 3.43377 33.9939 3.36661C33.9779 3.284 33.9259 3.1892 33.8336 3.11197C33.7413 3.03471 33.6401 3.00115 33.5584 3.00012C33.4929 2.99929 33.3947 3.01782 33.2708 3.13498Z\" fill=\"#5060C9\"\/\u003e\n\t\t\t\t\t\u003c\/svg\u003e\n\t\t\t\t\tProduct successfully added to your shopping cart\n\t\t\t\t\u003c\/h5\u003e\n\t\t\t\t\u003cdiv class=\"cart_added__1 mb-2 mt-3\" id=\"cart_added__img\"\u003e\n\t\t\t\t\t\u003cimg src=\"\" alt=\"\" class=\"img-fluid\" \/\u003e\n\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\u003ch6 id=\"cart_added__name\" class=\"product_name\"\u003e\u003c\/h6\u003e\n\t\t\t\u003c\/div\u003e\n\t\t\t\u003cdiv class=\"col-12 col-md-6 right-info\"\u003e\n\t\t\t\t\u003ch5 id=\"cart_added__total_quantity\" class=\"cart-title\"\u003e\n\t\t\t\t\t\u003csvg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\"\u003e\n\t\t\t\t\t\t\u003cpath d=\"M9.64301 11.5367C9.30818 9.69514 10.7229 8 12.5946 8H32.4053C34.2771 8 35.6918 9.69513 35.3569 11.5367L33.1751 23.5367C32.9158 24.9631 31.6734 26 30.2235 26H14.7764C13.3266 26 12.0842 24.9631 11.8248 23.5367L9.64301 11.5367Z\" fill=\"#FDA828\"\/\u003e\n\t\t\t\t\t\t\u003cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.4053 10H12.5946C11.9707 10 11.4991 10.565 11.6107 11.1789L13.7926 23.1789C13.879 23.6544 14.2931 24 14.7764 24H30.2235C30.7068 24 31.1209 23.6544 31.2074 23.1789L33.3892 11.1789C33.5008 10.565 33.0292 10 32.4053 10ZM12.5946 8C10.7229 8 9.30818 9.69514 9.64301 11.5367L11.8248 23.5367C12.0842 24.9631 13.3266 26 14.7764 26H30.2235C31.6734 26 32.9158 24.9631 33.1751 23.5367L35.3569 11.5367C35.6918 9.69513 34.2771 8 32.4053 8H12.5946Z\" fill=\"#5060C9\"\/\u003e\n\t\t\t\t\t\t\u003cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1C0 0.447715 0.447715 0 1 0H8.2C8.66593 0 9.07012 0.321779 9.17455 0.775852L11.4746 10.7759C11.5983 11.3141 11.2624 11.8508 10.7241 11.9746C10.1859 12.0983 9.64924 11.7624 9.52544 11.2241L7.40389 2H1C0.447715 2 0 1.55228 0 1Z\" fill=\"#5060C9\"\/\u003e\n\t\t\t\t\t\t\u003cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 34C17.1046 34 18 33.1046 18 32C18 30.8954 17.1046 30 16 30C14.8954 30 14 30.8954 14 32C14 33.1046 14.8954 34 16 34ZM16 36C18.2091 36 20 34.2091 20 32C20 29.7909 18.2091 28 16 28C13.7909 28 12 29.7909 12 32C12 34.2091 13.7909 36 16 36Z\" fill=\"#5060C9\"\/\u003e\n\t\t\t\t\t\t\u003cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29 34C30.1046 34 31 33.1046 31 32C31 30.8954 30.1046 30 29 30C27.8954 30 27 30.8954 27 32C27 33.1046 27.8954 34 29 34ZM29 36C31.2091 36 33 34.2091 33 32C33 29.7909 31.2091 28 29 28C26.7909 28 25 29.7909 25 32C25 34.2091 26.7909 36 29 36Z\" fill=\"#5060C9\"\/\u003e\n\t\t\t\t\t\u003c\/svg\u003e\n\t\t\t\t\tThere are \u003cspan\u003e\u003c\/span\u003e items in your cart.\n\t\t\t\t\u003c\/h5\u003e\n\t\t\t\t\u003cdiv class=\"total-wrap mt-3\"\u003e\n\t\t\t\t\t\u003cdiv id=\"cart_added__quantity\"\u003e\u003cspan class=\"label\"\u003eQuantity:\u003c\/span\u003e\u003cspan class=\"value\"\u003e\u003c\/span\u003e\u003c\/div\u003e\n\t\t\t\t\t\u003cdiv id=\"cart_added__price\"\u003e\u003cspan class=\"label\"\u003ePrice: \u003c\/span\u003e\u003cspan class=\"value product-price money\"\u003e\u003c\/span\u003e\u003c\/div\u003e\n\t\t\t\t\t\u003cdiv id=\"cart_added__total_price\"\u003e\u003cspan class=\"label\"\u003eTotal: \u003c\/span\u003e\u003cspan class=\"value product-price money\"\u003e\u003c\/span\u003e\u003c\/div\u003e\n\t\t\t\t\u003c\/div\u003e\n\t\t\t\t\u003cdiv class=\"cart-buttons mt-3\"\u003e\n\t\t\t\t\t\u003ca class=\"btn btn-primary d-block w-100 px-2\" id=\"cart_added__close\" href=\"#\"\u003e\u003cspan class=\"arrow-left\"\u003eContinue shopping\u003c\/span\u003e\u003c\/a\u003e\n\t\t\t\t\t\u003ca class=\"btn btn-secondary d-block w-100 px-2 mt-2\" href=\"\/cart\"\u003e\u003cspan class=\"arrow-right\"\u003eGo to cart\u003c\/span\u003e\u003c\/a\u003e\n\t\t\t\t\u003c\/div\u003e\n\t\t\t\u003c\/div\u003e\n\t\t\u003c\/div\u003e\n    \u003c\/div\u003e\n  ");

				if ( r.title.length < 60 ) {
					var productTitle = r.title;
				}
				else {
					var productTitle = $.trim( r.title ).substring(0, 60) + '...';
				};

				$('#cart_added__name').html( productTitle );
				$('#cart_added__price .value').html( Shopify.formatMoney(r.price, theme.moneyFormat));
				$('#cart_added__total_quantity .value').html( r.quantity );
				$('#cart_added__quantity .value').html(r.quantity);
				$('#cart_added__total_price .value').html( Shopify.formatMoney(r.final_line_price, theme.moneyFormat));
				$('#cart_added__close').on( 'click', function(e) {
					e.preventDefault();

					$('.fancybox-close').trigger('click');
				});

				if ( r.image ) {
					$('#cart_added__img img').attr( 'src', r.image.replace('.jpg','_300x300_crop_center.jpg').replace('.png','_200x267_crop_center.png') ).load( function() {
						$.fancybox.open( $('#cart_added'),
							{
								'openSpeed': 500,
								'closeSpeed': 300,
								'afterClose': function() {
									$('#cart_added').remove();
								}
							}
						);
					});
				}
				else {
					$('#cart_added__img').hide();
					$.fancybox.open( $('#cart_added'),
						{
							'openSpeed': 500,
							'closeSpeed': 300,
							'afterClose': function() {
								$('#cart_added').remove();
							}
						}
					);
				};

			},
			error: function(t, o) {
				Shopify.onError(t, o);

				var errorData = eval('(' + t.responseText + ')');

				$('body').append('<div id="cart_added" class="cart_error"><h4></h4><p class="alert alert-error"></p></div>');
				$('#cart_added h4').html( errorData.message );
				$('#cart_added p').html( errorData.description );

				$.fancybox.open( $('#cart_added'),
					{
						'openSpeed': 500,
						'closeSpeed': 300,
						'afterClose': function() {
							$('#cart_added').remove();
						}
					}
				);

			}
		};
		jQuery.ajax(r)
	}, Shopify.getCart = function(t) {
		jQuery.getJSON("/cart.js", function(o) {
			"function" == typeof t ? t(o) : Shopify.onCartUpdate(o)
		})
	}, Shopify.getProduct = function(t, o) {
		jQuery.getJSON("/products/" + t + ".js", function(t) {
			"function" == typeof o ? o(t) : Shopify.onProduct(t)
		})
	}, Shopify.changeItem = function(t, o, r) {
		var e = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=" + o + "&id=" + t,
			dataType: "json",
			success: function(t) {
				"function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(e)
	}, Shopify.removeItem = function(t, o) {
		var r = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=0&id=" + t,
			dataType: "json",
			success: function(t) {
				"function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(r)
	}, Shopify.clear = function(t) {
		var o = {
			type: "POST",
			url: "/cart/clear.js",
			data: "",
			dataType: "json",
			success: function(o) {
				"function" == typeof t ? t(o) : Shopify.onCartUpdate(o)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(o)
	}, Shopify.updateCartFromForm = function(t, o) {
		var r = {
			type: "POST",
			url: "/cart/update.js",
			data: jQuery(t).serialize(),
			dataType: "json",
			success: function(r) {
				"function" == typeof o ? o(r, t) : Shopify.onCartUpdate(r, t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(r)
	}, Shopify.updateCartAttributes = function(t, o) {
		var r = "";
		jQuery.isArray(t) ? jQuery.each(t, function(t, o) {
			var e = attributeToString(o.key);
			"" !== e && (r += "attributes[" + e + "]=" + attributeToString(o.value) + "&")
		}) : "object" == typeof t && null !== t && jQuery.each(t, function(t, o) {
			r += "attributes[" + attributeToString(t) + "]=" + attributeToString(o) + "&"
		});
		var e = {
			type: "POST",
			url: "/cart/update.js",
			data: r,
			dataType: "json",
			success: function(t) {
				"function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(e)
	}, Shopify.updateCartNote = function(t, o) {
		var r = {
			type: "POST",
			url: "/cart/update.js",
			data: "note=" + attributeToString(t),
			dataType: "json",
			success: function(t) {
				"function" == typeof o ? o(t) : Shopify.onCartUpdate(t)
			},
			error: function(t, o) {
				Shopify.onError(t, o)
			}
		};
		jQuery.ajax(r)
	};

  // WISHLIST
  
      const t = $(".zemez_wishlist_total");
      zemezWishlist = async e => {
        if (e.dataset.action === "remove" && location.href !== e.href) {
          location = e.href;
          return;
        }
        e.setAttribute("loading", "");
        e.setAttribute("disabled", "");
        await fetch("https://prestashop7.devoffice.com/shopify/wishlist.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(e.dataset)
        })
          .then(r => r.json())
          .then(r => {
            t.removeClass('hidden').html(r.total);
            if (e.dataset.action === "remove" && location.href === e.href) {
              location = e.href;
              return;
            }
            e.dataset.action = r.action;
            e.removeAttribute("loading");
            e.removeAttribute("disabled");
          });
      };
  

  

  // TABS
  $('.tab_content_wrapper').each(function(i) {
    var navItem = $(this).find('.tab_nav');
    var tabItem = $(this).find('.tab_item');
    navItem.on('click',function(e){
      navItem.removeClass('active');
      $(this).addClass('active');
      tabItem.removeClass('active');
      tabItem.eq($(this).data('tab')).addClass('active');
    });
  });


  // ACCORDION
  $('.product-accordion').each(function() {
    var accordionItem = $(this).find('.accordion-header');
    accordionItem.on('click',function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });
  });

  // lINKLIST IN MENU TOGGLE
  if ( $(window).innerWidth() < 768 ) {
    $('.toggle-mobile').each(function(){
      var navItem = $(this);
      var itemEl = navItem.parent().find('.content-toggle-mobile');
      itemEl.hide();
      navItem.on('click', function(){
        if (navItem.hasClass('open')) {
          itemEl.slideUp(400);
          navItem.removeClass('open');
        } else {
          itemEl.slideDown(400);
          navItem.addClass('open');
        }
      })
    });
  }

  // CLICKABLE COLOR OPTIONS
  $('.color_options_clickable').on('click', function(){
    var variantImage = $(this).data('image');
    if (variantImage.length > 0) {
      $(this).parent().parent().parent().parent().find('.product_img img').attr('src', variantImage);
    }
  });

  // SHOW POLICY PAGE
  $('.item_policy__link').on('click', function(e){
    if ( $(window).width() > 991 ) {
      e.preventDefault();
      var link = $(this).attr('href');
      $.ajax({
        url:link,
        type:'GET',
        success: function(data){
          var content = $(data).find('.main_content').html();
          $.fancybox(content,{
            'maxWidth': 768
          });
        }
      });
    }
  });

	// Transfer collection title block
	// var collection_content = $('.template-collection .collection_info');
	// var collection_position = $('.template-collection .collection_wrapper');
	// if ((collection_content).length) {
	// 	(collection_content).appendTo(collection_position);
	// }
});

// const dropdownSVG = '<svg width="9" height="6" viewBox="0 0 9 6" xmlns="http://www.w3.org/2000/svg"><path d="M9 1.5L7.5 0L4.5 3L1.5 0L0 1.5L4.5 6L9 1.5Z"/></svg>';
// // Init custom select
// $('body').delegate(".custom-option", "click", function() {
// 	$(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
// 	$(this).parents(".custom-options").find(".custom-option").removeClass("selection");
// 	$(this).addClass("selection");
// 	$(this).parents(".select-wrapper").removeClass("opened");
// 	$(this).parents(".select-wrapper").find(".custom-select-trigger").html($(this).text() + dropdownSVG);
// 	$(this).parents(".custom-select-wrapper").find('select').trigger('change');
// });
//
// $('body').delegate(".custom-select-trigger", "click", function(event) {
// 	$('html').on('click',function() {
// 		$(".select-wrapper").removeClass("opened");
// 	});
// 	$(this).parents(".select-wrapper").toggleClass("opened");
// 	event.stopPropagation();
// });
//
// $('.custom-select').each(function() {
// 	var $this = $(this);
// 	var classes = $this.attr("class"),
// 		id = $this.attr("id"),
// 		name = $this.attr("name");
// 	var template =  '<div class="select-wrapper">';
// 	const selectedOption = $this.find("option[selected]");
// 	const selectedOptionLabel = selectedOption.length ? selectedOption[0].innerHTML + dropdownSVG : '';
// 	template += '<span class="custom-select-trigger custom-select">' + selectedOptionLabel + '</span>';
// 	template += '<div class="custom-options">';
// 	$this.find("option").each(function() {
// 		const className = this.hasAttribute('selected') ? 'selection' : '';
// 		template += `<span class="custom-option ${className}" data-value="${$(this).attr("value")}">${$(this).html()}</span>`;
// 	});
// 	template += '</div></div>';
// 	$this.wrap('<div class="custom-select-wrapper"></div>');
// 	$this.hide();
// 	$this.after(template);
//
// 	if (!selectedOption.length){
// 		$this.find('.custom-option').first().click();
// 	}
// });

/**
 * @module       Parallax.js
 * @author       Matthew Wagerfield - @wagerfield
 * @license      MIT
 */
!function(a,b,c){"use strict";function g(a,b){this.element=a,this.layers=a.getElementsByClassName("layer");var c={calibrateX:this.data(this.element,"calibrate-x"),calibrateY:this.data(this.element,"calibrate-y"),invertX:this.data(this.element,"invert-x"),invertY:this.data(this.element,"invert-y"),limitX:this.data(this.element,"limit-x"),limitY:this.data(this.element,"limit-y"),scalarX:this.data(this.element,"scalar-x"),scalarY:this.data(this.element,"scalar-y"),frictionX:this.data(this.element,"friction-x"),frictionY:this.data(this.element,"friction-y"),originX:this.data(this.element,"origin-x"),originY:this.data(this.element,"origin-y")};for(var d in c)null===c[d]&&delete c[d];this.extend(this,f,b,c),this.calibrationTimer=null,this.calibrationFlag=!0,this.enabled=!1,this.depths=[],this.raf=null,this.bounds=null,this.ex=0,this.ey=0,this.ew=0,this.eh=0,this.ecx=0,this.ecy=0,this.erx=0,this.ery=0,this.cx=0,this.cy=0,this.ix=0,this.iy=0,this.mx=0,this.my=0,this.vx=0,this.vy=0,this.onMouseMove=this.onMouseMove.bind(this),this.onDeviceOrientation=this.onDeviceOrientation.bind(this),this.onOrientationTimer=this.onOrientationTimer.bind(this),this.onCalibrationTimer=this.onCalibrationTimer.bind(this),this.onAnimationFrame=this.onAnimationFrame.bind(this),this.onWindowResize=this.onWindowResize.bind(this),this.initialise()}var d="Parallax",e=30,f={relativeInput:!1,clipRelativeInput:!1,calibrationThreshold:100,calibrationDelay:500,supportDelay:500,calibrateX:!1,calibrateY:!0,invertX:!0,invertY:!0,limitX:!1,limitY:!1,scalarX:10,scalarY:10,frictionX:.1,frictionY:.1,originX:.5,originY:.5};g.prototype.extend=function(){if(arguments.length>1)for(var a=arguments[0],b=1,c=arguments.length;b<c;b++){var d=arguments[b];for(var e in d)a[e]=d[e]}},g.prototype.data=function(a,b){return this.deserialize(a.getAttribute("data-"+b))},g.prototype.deserialize=function(a){return"true"===a||"false"!==a&&("null"===a?null:!isNaN(parseFloat(a))&&isFinite(a)?parseFloat(a):a)},g.prototype.camelCase=function(a){return a.replace(/-+(.)?/g,function(a,b){return b?b.toUpperCase():""})},g.prototype.transformSupport=function(d){for(var e=b.createElement("div"),f=!1,g=null,h=!1,i=null,j=null,k=0,l=this.vendors.length;k<l;k++)if(null!==this.vendors[k]?(i=this.vendors[k][0]+"transform",j=this.vendors[k][1]+"Transform"):(i="transform",j="transform"),e.style[j]!==c){f=!0;break}switch(d){case"2D":h=f;break;case"3D":if(f){var m=b.body||b.createElement("body"),n=b.documentElement,o=n.style.overflow;b.body||(n.style.overflow="hidden",n.appendChild(m),m.style.overflow="hidden",m.style.background=""),m.appendChild(e),e.style[j]="translate3d(1px,1px,1px)",g=a.getComputedStyle(e).getPropertyValue(i),h=g!==c&&g.length>0&&"none"!==g,n.style.overflow=o,m.removeChild(e)}}return h},g.prototype.ww=null,g.prototype.wh=null,g.prototype.wcx=null,g.prototype.wcy=null,g.prototype.wrx=null,g.prototype.wry=null,g.prototype.portrait=null,g.prototype.desktop=!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i),g.prototype.vendors=[null,["-webkit-","webkit"],["-moz-","Moz"],["-o-","O"],["-ms-","ms"]],g.prototype.motionSupport=!!a.DeviceMotionEvent,g.prototype.orientationSupport=!!a.DeviceOrientationEvent,g.prototype.orientationStatus=0,g.prototype.propertyCache={},g.prototype.initialise=function(){g.prototype.transform2DSupport===c&&(g.prototype.transform2DSupport=g.prototype.transformSupport("2D"),g.prototype.transform3DSupport=g.prototype.transformSupport("3D")),this.transform3DSupport&&this.accelerate(this.element);var b=a.getComputedStyle(this.element);"static"===b.getPropertyValue("position")&&(this.element.style.position="relative"),this.updateLayers(),this.updateDimensions(),this.enable(),this.queueCalibration(this.calibrationDelay)},g.prototype.updateLayers=function(){this.layers=this.element.getElementsByClassName("layer"),this.depths=[];for(var a=0,b=this.layers.length;a<b;a++){var c=this.layers[a];this.transform3DSupport&&this.accelerate(c),c.style.position=a?"absolute":"relative",c.style.display="block",c.style.left=0,c.style.top=0,this.depths.push(this.data(c,"depth")||0)}},g.prototype.updateDimensions=function(){this.ww=a.innerWidth,this.wh=a.innerHeight,this.wcx=this.ww*this.originX,this.wcy=this.wh*this.originY,this.wrx=Math.max(this.wcx,this.ww-this.wcx),this.wry=Math.max(this.wcy,this.wh-this.wcy)},g.prototype.updateBounds=function(){this.bounds=this.element.getBoundingClientRect(),this.ex=this.bounds.left,this.ey=this.bounds.top,this.ew=this.bounds.width,this.eh=this.bounds.height,this.ecx=this.ew*this.originX,this.ecy=this.eh*this.originY,this.erx=Math.max(this.ecx,this.ew-this.ecx),this.ery=Math.max(this.ecy,this.eh-this.ecy)},g.prototype.queueCalibration=function(a){clearTimeout(this.calibrationTimer),this.calibrationTimer=setTimeout(this.onCalibrationTimer,a)},g.prototype.enable=function(){this.enabled||(this.enabled=!0,this.orientationSupport?(this.portrait=null,a.addEventListener("deviceorientation",this.onDeviceOrientation),setTimeout(this.onOrientationTimer,this.supportDelay)):(this.cx=0,this.cy=0,this.portrait=!1,a.addEventListener("mousemove",this.onMouseMove)),a.addEventListener("resize",this.onWindowResize),this.raf=requestAnimationFrame(this.onAnimationFrame))},g.prototype.disable=function(){this.enabled&&(this.enabled=!1,this.orientationSupport?a.removeEventListener("deviceorientation",this.onDeviceOrientation):a.removeEventListener("mousemove",this.onMouseMove),a.removeEventListener("resize",this.onWindowResize),cancelAnimationFrame(this.raf))},g.prototype.calibrate=function(a,b){this.calibrateX=a===c?this.calibrateX:a,this.calibrateY=b===c?this.calibrateY:b},g.prototype.invert=function(a,b){this.invertX=a===c?this.invertX:a,this.invertY=b===c?this.invertY:b},g.prototype.friction=function(a,b){this.frictionX=a===c?this.frictionX:a,this.frictionY=b===c?this.frictionY:b},g.prototype.scalar=function(a,b){this.scalarX=a===c?this.scalarX:a,this.scalarY=b===c?this.scalarY:b},g.prototype.limit=function(a,b){this.limitX=a===c?this.limitX:a,this.limitY=b===c?this.limitY:b},g.prototype.origin=function(a,b){this.originX=a===c?this.originX:a,this.originY=b===c?this.originY:b},g.prototype.clamp=function(a,b,c){return a=Math.max(a,b),a=Math.min(a,c)},g.prototype.css=function(a,b,d){var e=this.propertyCache[b];if(!e)for(var f=0,g=this.vendors.length;f<g;f++)if(e=null!==this.vendors[f]?this.camelCase(this.vendors[f][1]+"-"+b):b,a.style[e]!==c){this.propertyCache[b]=e;break}a.style[e]=d},g.prototype.accelerate=function(a){this.css(a,"transform","translate3d(0,0,0)"),this.css(a,"transform-style","preserve-3d"),this.css(a,"backface-visibility","hidden")},g.prototype.setPosition=function(a,b,c){b+="px",c+="px",this.transform3DSupport?this.css(a,"transform","translate3d("+b+","+c+",0)"):this.transform2DSupport?this.css(a,"transform","translate("+b+","+c+")"):(a.style.left=b,a.style.top=c)},g.prototype.onOrientationTimer=function(){this.orientationSupport&&0===this.orientationStatus&&(this.disable(),this.orientationSupport=!1,this.enable())},g.prototype.onCalibrationTimer=function(){this.calibrationFlag=!0},g.prototype.onWindowResize=function(){this.updateDimensions()},g.prototype.onAnimationFrame=function(){this.updateBounds();var a=this.ix-this.cx,b=this.iy-this.cy;(Math.abs(a)>this.calibrationThreshold||Math.abs(b)>this.calibrationThreshold)&&this.queueCalibration(0),this.portrait?(this.mx=this.calibrateX?b:this.iy,this.my=this.calibrateY?a:this.ix):(this.mx=this.calibrateX?a:this.ix,this.my=this.calibrateY?b:this.iy),this.mx*=this.ew*(this.scalarX/100),this.my*=this.eh*(this.scalarY/100),isNaN(parseFloat(this.limitX))||(this.mx=this.clamp(this.mx,-this.limitX,this.limitX)),isNaN(parseFloat(this.limitY))||(this.my=this.clamp(this.my,-this.limitY,this.limitY)),this.vx+=(this.mx-this.vx)*this.frictionX,this.vy+=(this.my-this.vy)*this.frictionY;for(var c=0,d=this.layers.length;c<d;c++){var e=this.layers[c],f=this.depths[c],g=this.vx*f*(this.invertX?-1:1),h=this.vy*f*(this.invertY?-1:1);this.setPosition(e,g,h)}this.raf=requestAnimationFrame(this.onAnimationFrame)},g.prototype.onDeviceOrientation=function(a){if(!this.desktop&&null!==a.beta&&null!==a.gamma){this.orientationStatus=1;var b=(a.beta||0)/e,c=(a.gamma||0)/e,d=this.wh>this.ww;this.portrait!==d&&(this.portrait=d,this.calibrationFlag=!0),this.calibrationFlag&&(this.calibrationFlag=!1,this.cx=b,this.cy=c),this.ix=b,this.iy=c}},g.prototype.onMouseMove=function(a){var b=a.clientX,c=a.clientY;!this.orientationSupport&&this.relativeInput?(this.clipRelativeInput&&(b=Math.max(b,this.ex),b=Math.min(b,this.ex+this.ew),c=Math.max(c,this.ey),c=Math.min(c,this.ey+this.eh)),this.ix=(b-this.ex-this.ecx)/this.erx,this.iy=(c-this.ey-this.ecy)/this.ery):(this.ix=(b-this.wcx)/this.wrx,this.iy=(c-this.wcy)/this.wry)},a[d]=g}(window,document);

// Enable parallax by mouse
var parallaxJs = document.getElementsByClassName('parallax-scene');
$(document).ready(function () {
  if(parallaxJs) {
    for(var i = 0; i < parallaxJs.length; i++){
      var scene = parallaxJs[i];
      new Parallax(scene);
    }
  }
});




// COUNTDOWN TIMER //////////////////////////////////////////////////////////////////////////////////////////////////////////
$.fn.ccountdown = function(_yr, _m, _d, _t, callback) {
	var $this = this;
	var interval;
	var _montharray = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
	var _today = new Date();
	// calling function first time so that it wll setup remaining time
	var _changeTime = function() {
		var _today = new Date();
		var _todayy = _today.getYear();
		if (_todayy < 1000)
			_todayy += 1900;
		var _todaym = _today.getMonth();
		var _todayd = _today.getDate();
		var _todayh = _today.getHours();
		var _todaymin = _today.getMinutes();
		var _todaysec = _today.getSeconds();
		_todaysec = "0" + _todaysec;
		_todaysec = _todaysec.substr(_todaysec.length - 2);
		var _todaystring = _montharray[_todaym] + " " + _todayd + ", " + _todayy + " " + _todayh + ":" + _todaymin + ":" + _todaysec;
		var _futurestring = _montharray[_m - 1] + " " + _d + ", " + _yr + " " + _t;
		/* calculation of remaining days, hrs, min, and secs */
		_dd = Date.parse(_futurestring) - Date.parse(_todaystring);
		_dday = Math.floor(_dd / (60 * 60 * 1000 * 24) * 1);
		_dhour = Math.floor((_dd % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000) * 1);
		_dmin = Math.floor(((_dd % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
		_dsec = Math.floor((((_dd % (60 * 60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);
		var el = $($this);
		var $ss = el.find(".second"), $mm = el.find(".minute"), $hh = el.find(".hour"), $dd = el.find(".days");
		$ss.val(_dsec).trigger("change");
		$mm.val(_dmin).trigger("change");
		$hh.val(_dhour).trigger("change");
		$dd.val(_dday).trigger("change");
		if (_dd <= 0){
			$ss.val('0');
			$mm.val('0');
			$hh.val('0');
			$dd.val('0');
			window.clearInterval(interval);
			if (typeof callback == 'function'){
				callback.call(this);
			}
		}
	};

	_changeTime();

	interval = setInterval(_changeTime, 1000);
};